import { environment } from "./environment";

const hostname = window.location.hostname;
const hostnameSplited = hostname.split(".");
let url = `${environment.protocol}${environment.subdomains[0]}.${environment.hubioIp}`;

if (hostnameSplited && hostnameSplited.length > 0 && hostnameSplited[0]) {
    let subdomainSearch: string | undefined = undefined;
    switch (hostnameSplited[0]) {
        case "gyc":
        case "drgyc":
        case "drmpc":
        case "mpc":
        case "drcentromater":
        case "centromater":
        case "drhubio": 
        case "hubio": 
        case "drschiller": 
        case "schiller": 
            subdomainSearch = environment.subdomains.find(sub => sub === hostnameSplited[0]);
            if (subdomainSearch) {
                url = `${environment.protocol}${subdomainSearch}.${environment.hubioIp}`;
            }
            break;
        default:
            break;
    }
}
export const socket_url = `${url}`;
export const socket_path = "/voice-call-server/socket.io";
export const agora = {
  appID: "b1503e00d0434af3915e94856de75671",
  appCertificate: "7c648d28a3244e80a7f6ec23a69741ec"
};
